import apiBase from "@/api/unversioned/apiBase";
import { PerformanceDataRequestPayload, TimelineDataRequestPayload } from "@/views/CarrierPerformanceView/types";
import { type AxiosRequestConfig } from "axios";

const baseURL = `${import.meta.env.VITE_API_BASE_URL}/carrier-performance/query`;

const reliabilityQuery = (
  endpoint: string,
  payload: PerformanceDataRequestPayload | TimelineDataRequestPayload,
  config?: AxiosRequestConfig
) => {
  const queryString = new URLSearchParams(
    Object.entries(payload)
      .filter(([, value]) => value !== undefined && value !== null)
      .flatMap(([key, value]) => (Array.isArray(value) ? value.map((v) => [key, String(v)]) : [[key, String(value)]]))
  ).toString();

  return apiBase("get", `${baseURL}/reliability/${endpoint}?${queryString}`, config);
};

const performanceByCarrier = (payload: PerformanceDataRequestPayload, config?: AxiosRequestConfig) =>
  reliabilityQuery("carrier", payload, config);

const performanceByGeography = (payload: PerformanceDataRequestPayload, config?: AxiosRequestConfig) =>
  reliabilityQuery("geography", payload, config);

const reliabilityTimeline = (payload: TimelineDataRequestPayload, config?: AxiosRequestConfig) =>
  reliabilityQuery("timeline", payload, config);

export { performanceByCarrier, performanceByGeography, reliabilityTimeline };
